<template>
  <div class="d-flex" id="wrapper">
    <Sidebar :toggler.sync="isToggled" />
    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />

      <Message class="mr-4 ml-4 error" type="error-alert" v-show="getErrorMessage">
        <h4 slot="heading" class="alert-heading">Error</h4>
        <p slot="alert-message" class="mb-0">
          {{ getErrorMessage }}
        </p>
      </Message>

      <section id="description" style="overflow: hidden">
        <div class="row">
          <div class="col-md-8">
            <CandidateItemInfo :key="key" @reloadCandidate="reloadActivity" />
            <div class="card custom-card candidate-documents">
              <CandidateItemDocuments />
            </div>
          </div>
          <div class="col-md-4 d-none d-sm-block candidate-aside">
            <Activities
              :activities="currentActivities"
              @added-new-activity="reloadActivity"
              @removed-activity="reloadActivity"
              @getActivities="loadMoreActivities"
              hasAddActivityButton
            />
            <Emails :emails="getCandidateById.emails" :attachments="getEmailAttachments" />
          </div>
        </div>
        <div class="row d-none d-sm-block candidate-pipeline">
          <div class="col-md-12">
            <div class="card">
              <CandidateItemPipeline
                @reload-activity="reloadActivity"
                @reload-pipeline="getNewPipelines"
              />
            </div>
          </div>
        </div>
        <Spinner :isLoading="isLoading" />
      </section>
    </div>

    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { toggleSidebarNav } from '../../../mixins/toggleSidebarNav';
import CandidateItemInfo from '@/components/Admin/Candidates/CandidateItemInfo';
import Sidebar from '../../Navigations/Sidebar';
import TopNavbar from '../../Navigations/TopNavbar';
import Emails from '../common/Emails';
import Activities from '../common/Activities';

import CandidateItemPipeline from '../Candidates/CandidateItemPipeline';
import CandidateItemDocuments from '../Candidates/CandidateItemDocuments';

import Message from '../../AlertMessages/Message';

import { errorService } from '../../../services/errorService';
export default {
  components: {
    Sidebar,
    TopNavbar,
    CandidateItemInfo,
    Emails,
    Activities,
    CandidateItemPipeline,
    CandidateItemDocuments,
    Message,
  },
  mixins: [toggleSidebarNav],

  data: () => ({
    showModal: false,
    isToggled: false,
    isLoading: false,
    selected: [],
    isCurrentRowChecked: false,
    currentItemIds: [],
    currentActivities: [],
    oldIndex: '',
    newIndex: '',
    key: 0,
    isErrorMessage: false,
    currentPage: 1,
    pageCount: 10,
    last_page: '',
  }),
  methods: {
    ...mapActions([
      'retrieveCandidateById',
      'retrieveCandidateEmails',
      'retrieveUserProfile',
      'retrieveCandidatePipelines',
      'retrieveCandidateActivities',
    ]),
    loadMoreActivities() {
      if (this.currentPage < this.last_page) {
        this.currentPage++;
        this.retrieveCandidateActivities({
          candidate_id: this.$route.params.candidate_id,
          count: this.pageCount,
          page: this.currentPage,
        }).then(() => {
          this.currentActivities = [
            ...this.currentActivities,
            ...Object.values(this.getCandidateActivities.data),
          ];
        });
      }
    },
    reloadActivity() {
      this.retrieveCandidateActivities({
        candidate_id: this.$route.params.candidate_id,
        count: this.pageCount,
        page: 1,
      }).then(() => {
        this.currentActivities = this.getCandidateActivities.data;
        this.last_page = this.getCandidateActivities.last_page;
      });
    },
    getNewActivites() {
      this.retrieveCandidateById({ uuid: this.$route.params.candidate_id });
    },
    toggleSidebarNav() {
      this.isToggled = !this.isToggled;
    },
    updateName() {
      this.candidateName = this.$route.params.candidate_name;
    },
    forceRerender() {
      this.key += 1;
    },
    getNewPipelines({ page, count }) {
      this.retrieveCandidatePipelines({
        candidate_id: this.$route.params.candidate_id,
        search_word: '',
        page,
        count,
      })
        .then(() => {
          this.isLoading = false;

          this.reloadActivity();
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
  },
  watch: {
    $route: 'updateName',
  },
  computed: {
    ...mapGetters([
      'getCandidateById',
      'getErrorMessage',
      'getCandidateEmails',
      'getUserProfile',
      'getEmailAttachments',
      'getCandidatePipelines',
      'getCandidateActivities',
      'getCandidateById',
    ]),
  },
  mounted() {
    this.isLoading = true;

    this.retrieveUserProfile().then(() => {
      this.retrieveCandidateActivities({
        candidate_id: this.$route.params.candidate_id,
        count: this.pageCount,
        page: this.currentPage,
      }).then(() => {
        this.currentActivities = this.getCandidateActivities.data;
        this.last_page = this.getCandidateActivities.last_page;
      });

      this.retrieveCandidateById({ uuid: this.$route.params.candidate_id })
        .then(() => {
          this.retrieveEmailAttachments({ attachmentId: '' });
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });

      /* Retrieve pipelines */
      this.retrieveCandidatePipelines({
        candidate_id: this.$route.params.candidate_id,
        search_word: '',
        page: 1,
        count: 10,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

#description {
  padding: 0 24px;
  .card {
    margin: 0 0 24px 0 !important;
  }
}
/deep/ .scroll {
  max-height: 865px;
}

@media only screen and (max-width: 1251px) {
  #description {
    .card {
      margin: 26px 0 0 0 !important;
      border-bottom-left-radius: 18px;
      border-bottom-right-radius: 18px;
    }
  }
  .candidate-aside {
    display: none !important;
  }
}

@media only screen and (max-width: 992px) {
  #description {
    .col-md-8 {
      display: block;
      flex: 100%;
      width: 100% !important;
      max-width: 100%;
    }
    padding: 0 !important;
    .card {
      margin: 26px 0 0 0 !important;
      border-top-left-radius: 18px;
      border-top-right-radius: 18px;
    }
    .candidate-aside {
      display: none !important;
    }
    .candidate-pipeline {
      display: none !important;
      .card {
        border-radius: 0 !important;
      }
    }
    .candidate-documents {
      display: none !important;
    }
  }
}

@media only screen and (max-width: 768px) {
  #description {
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      border-top-left-radius: 18px;
      border-top-right-radius: 18px;
    }

    .candidate-aside {
      display: none !important;
    }
    .candidate-pipeline {
      display: none !important;
      .card {
        border-radius: 0 !important;
      }
    }
    .candidate-documents {
      display: none !important;
    }
  }
}

@media only screen and (max-width: 576px) {
  #description {
    padding: 0;
    .card {
      margin: 0 0 24px 0 !important;
    }
  }
  .error {
    margin: 5px 0 10px 0;
  }
}
</style>
